// React, Next
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Link from 'next/link'

// MUI
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

// Custom
import Section from '@/components/sections/Section'
import { translateHref } from 'assets/functions/links'

// Config
import i18nextConfig from 'next-i18next.config'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody, getFontH2 } from '@/assets/theme/fonts'

export default function CtaSection() {
  const { t } = useTranslation('index')

  const router = useRouter()
  const currentLocale = router.query.locale || i18nextConfig.i18n.defaultLocale

  const getContent = () => (
    <Box sx={{ width: '100%', maxWidth: '44rem', textAlign: 'center' }}>
      <Typography
        variant="h2"
        component="h2"
        fontSize={getFontH2()}
        sx={{
          fontWeight: 700,
          lineHeight: 1.25,
          color: '#fff',
          marginBottom: '1.5rem'
        }}
      >
        {t('cta.title')}
      </Typography>

      {[t('cta.p1'), t('cta.p2')].map(paragraph => (
        <Typography
          key={paragraph}
          component="p"
          fontSize={getFontBody()}
          sx={{
            lineHeight: 1.75,
            color: 'rgba(255,255,255,0.82)',
            marginBottom: '1rem'
          }}
        >
          {paragraph}
        </Typography>
      ))}

      <Typography
        component="p"
        sx={{
          marginTop: '2rem',
          fontSize: '0.8rem',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: themeColors.success.main
        }}
      >
        {t('cta.slogan')}
      </Typography>

      <Link
        href={translateHref(currentLocale, 'contact')}
        style={{ textDecoration: 'none' }}
      >
        <Button
          variant="contained"
          endIcon={<ArrowForwardIosIcon sx={{ transform: 'scale(0.7)' }} />}
          sx={{
            marginTop: '1.5rem',
            background: themeColors.success.main,
            borderRadius: '4px',
            padding: '0.8rem 1.75rem',
            fontWeight: 600,
            letterSpacing: '0.03em',
            boxShadow: 'none',
            '&:hover': {
              background: themeColors.success.darker,
              boxShadow: 'none'
            }
          }}
        >
          {t('cta.button')}
        </Button>
      </Link>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.dunkelblau}
      paddingTop="6rem"
      paddingBottom="6rem"
      content={getContent()}
    />
  )
}
